import { PlusCircle } from 'lucide-react'
import React from 'react'

const AddOneButton = ({ onClick, label }) => {
  return (
    <button onClick={onClick} className="bg-[#b07d17] text-white border-transparent px-6 py-2 rounded-lg flex items-center gap-2 capitalize hover:bg-[#8c6312] transition">
      <PlusCircle className="w-5 h-5" />
      {label}
    </button>
  )
}

export default AddOneButton